import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import React from "react";
import TaskCard from "./TareaTarjeta";

const SortableTaskCard = ({ task, onOpen, onDelete, onView, employeesById }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: task.id,
        data: { type: 'task', taskId: task.id, columnId: task.columnId },
    })
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
    }
    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <TaskCard task={task} onOpen={onOpen} onDelete={onDelete} onView={onView} employeesById={employeesById} />
        </div>
    )
}

export default SortableTaskCard;